import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import "./index_custom.css";
import reportWebVitals from "./reportWebVitals";
import { taiCauHinhGiaoDien } from "./runtimeConfig";
import { store } from "./state/store";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

// Nạp cấu hình giao diện TRƯỚC khi render: tên đơn vị / logo / màu phải đúng ngay từ màn đăng
// nhập, render trước rồi mới đổi thì người dùng thấy giao diện nhấp nháy đổi màu.
// Hàm này tự nuốt lỗi — không lấy được cấu hình thì chạy bằng .env như trước.
taiCauHinhGiaoDien().finally(() => {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>,
  );

  reportWebVitals();
});
